import React from 'react';

const Dashboard = () => {
  return (
    <div>
      <p>Testing things</p>
    </div>
  );
};

export default Dashboard;
